<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :tablePage="page"
      :loading="loading"
      @submit="reload"
    >
      <page-header
        ref="header"
        @add="add"
        @submit="handleSubmit"
        @reset="reset"
      />
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        @change="handlePaginationChange"
        slot="pager"
      />
    </page-main>
  </div>
</template>

<script>
export default {
  name: 'system-sysuser',
  components: {
    PageHeader: () => import('./header'),
    PageMain: () => import('./main'),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      }
    },
    add() {
      this.$refs.main.fromLoad('add', '1')
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .sysUserListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
